import { getLocale } from "@kunduz/feature-website-common";
import axios from "axios";
import { getCookie } from "cookies-next";
import { onBannedErrorMiddleware } from "./bannedErrorMiddleware";

const _apiClient = axios.create({
  baseURL: process.env["NEXT_PUBLIC_KUNDUZ_API_URL"],
});
_apiClient.interceptors.request.use(
  (config) => {
    const token = getCookie("kz_user_token");
    if (token) {
      config.headers["Authorization"] = `Token ${token}`;
    }

    if (typeof window !== "undefined") {
      const iso = getLocale({
        i18nextLocale: window.lang,
      }).iso;
      if (iso) {
        config.headers["KZ-COUNTRY-ISO-CODE"] = iso;
      }
    }

    config.headers["CLIENT-TYPE"] = "web";
    config.headers["CLIENT-APP-VERSION"] = "0.30.0";

    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

_apiClient.interceptors.response.use(
  (response) => response,
  onBannedErrorMiddleware,
);

export const apiClient = _apiClient;
